<div class="text-center flex flex-column justify-content-center h-screen">
  <div class="mb-0">
    <img class="m-auto max-w-15rem" src="assets/FP-logo.png" alt="Logo" />
  </div>
  <h1 class="text-5xl">{{ 'SERVICE_PAGES.FAREWELL.TITLE' | translate }} 👋</h1>
  <p class="text-xl">{{ 'SERVICE_PAGES.FAREWELL.MESSAGE' | translate }}</p>
</div>
